var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoRegistro1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icono-registro-1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icono-registro-1",
    clipPath: "url(#clip-icono-registro-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_20",
    "data-name": "Sustracci\\xF3n 20",
    d: "M10719,3811.24h-14v-2.327h14v-4.749h2v4.738A2.191,2.191,0,0,1,10719,3811.24Zm-8-5.9,0,0-4-4.723,4-4.725v3.543h10v2.362h-10v3.543Zm-10-7.356h-2v-5.626a2.207,2.207,0,0,1,2-2.362h18a2.206,2.206,0,0,1,2,2.362v4.714h-2v-4.738h-18v5.649Z",
    transform: "translate(-10683 -3785.99)",
    fill: "#225b2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_input_24px",
    d: "M18,3.01H3A2.211,2.211,0,0,0,1,5.373v4.713H3V5.349H18V21.923H3V17.174H1v4.737A2.188,2.188,0,0,0,3,24.25H18a2.188,2.188,0,0,0,2-2.339V5.373A2.2,2.2,0,0,0,18,3.01ZM11,18.355l4-4.725L11,8.9v3.544H1v2.363H11Z",
    transform: "translate(1 10)",
    fill: "#225b2a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoRegistro1);
export default __webpack_public_path__ + "static/media/icono-registro-1.49a56cf82e30e31c87f47791a28a4528.svg";
export { ForwardRef as ReactComponent };